// extracted by mini-css-extract-plugin
export default {"tooltip":"RoleDescriptionTooltip__tooltip-eVopq"};